import { ProductFavorites } from '/Foundation/React/code/Components/ProductFavoritesHelper';

document.addEventListener('DOMContentLoaded', function () {
  if (!_THULEDATA.isB2CEnabled) return;
  ProductFavorites.init();
});
